export default "__VITE_ASSET__CPntV0XU__"